import type { SupportedPoint } from '@common/api/graphql/getGifteeBoxTemplatesGql';

export const isSupportedPoint = (
  point: number,
  supportedPoint: SupportedPoint
): boolean =>
  point >= supportedPoint.minPoint &&
  point <= supportedPoint.maxPoint &&
  point % supportedPoint.step === 0;
